export default function ClientDetails({ documentType, clientName, clientAddress }) {
  return (
    <>
      <section className="mt-10">
        <h2 className="text-2xl uppercase font-bold mb-1">{documentType}</h2>
        <p>{clientName}</p>
        <p>{clientAddress}</p>
      </section>
    </>
  )
}
